<template>
  <div class="mx-3" style="font-size: 14px !important">
    <v-card
      class="mt-1"
      elevation="0"
    >
      <v-card-text
        class="py-1 px-1"
        style="position: relative;"
      >
        <div style="display:flex;" class="border-user">
          <v-img style="max-width: 25px !important; height: 30px;" src="../assets/icons/user_mark.svg"></v-img>
          <span class="ml-2" style="font-weight: bold;">{{getDirections.start_address}}</span>
          
        </div>
        <div class="mt-2" style="text-align: center; color: #009640;">
          {{getDirections.distance}} , {{getDirections.duration}} aproximadamente 
        </div>
      </v-card-text>
    </v-card>

    <div class="py-2 pl-3">
      <template v-for="(item, index) in getDirections.steps">
        <div v-bind:key="index" style="font-size: 12px !important" class="mb-1">
          <div>
            
            <div v-if="!item.steps && item.transit" style="display: block !important; color: #8995A2">
              <span class="ml-2 mt-1 font-weight-bold">{{item.transit.departure_stop.name}}.</span>
              <div style="display:flex">
                <v-img style="max-width: 16px !important; height: 17px;" :alt="item.transit.line.vehicle.icon" src="../assets/icons/bus_opac.svg"></v-img>
                <div class="ml-2">
                  <span class="white--text px-2" style="background-color: #8995A2; padding-top: 2px; padding-bottom: 2px">{{item.transit.line.short_name}}</span>
                  <span class="ml-1" v-html="item.instructions"></span>
                  <span class="ml-1">({{item.duration.text}}, {{item.transit.num_stops}} paradas).</span>
                  <span class="ml-1">{{item.transit.arrival_stop.name}}.</span>
                  <span class="ml-1">Servicio prestado por:</span>
                  <a class="ml-1" :href="item.transit.line.agencies[0].url" target="_blank">{{item.transit.line.agencies[0].name}}</a>
                </div>
              </div>                    
              <span class="ml-2 mb-1 font-weight-bold">{{item.transit.arrival_stop.name}}.</span>
            </div>

            <div v-if="!item.steps && item.transit == null" style="display:flex">
              <v-img v-if="item.maneuver == ''" style="max-width: 16px !important; height: 20px;" src="../assets/icons/walk_opac.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'fork-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/fork-left.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'fork-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/fork-right.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'fork'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/fork.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'merge-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/merge-left.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'merge-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/merge-right.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'merge'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/merge.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'ramp-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/ramp-left.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'ramp-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/ramp-right.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'roundabout-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/roundabout-left.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'roundabout-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/roundabout-right.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'straight'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/straight.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'turn-left'" style="max-width: 14px !important; height: 15px; color: #8995A2" src="../assets/icons/directions/turn-left.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'turn-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/turn-right.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'turn-sharp-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/turn-sharp-left.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'turn-sharp-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/turn-sharp-right.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'turn-slight-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/turn-slight-left.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'turn-slight-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/turn-slight-right.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'uturn-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/uturn-left.svg"></v-img>
              <v-img v-else-if="item.maneuver == 'uturn-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/uturn-right.svg"></v-img>
              <v-img v-else style="min-width: 14px !important; height: 15px; color: #fff" ></v-img>                  
              
              <span class="ml-2" style="color: #8995A2" v-html="item.instructions"></span>
            </div>

            <template v-if="item.steps">
              <div v-for="(ite, i) in item.steps" v-bind:key="i" style="display: block !important;">
                <div style="display: flex;">
                  <v-img v-if="ite.maneuver == ''" style="max-width: 15px !important; height: 17px;" src="../assets/icons/walk_opac.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'fork-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/fork-left.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'fork-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/fork-right.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'fork'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/fork.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'merge-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/merge-left.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'merge-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/merge-right.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'merge'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/merge.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'ramp-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/ramp-left.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'ramp-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/ramp-right.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'roundabout-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/roundabout-left.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'roundabout-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/roundabout-right.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'straight'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/straight.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'turn-left'" style="max-width: 14px !important; height: 15px; color: #8995A2" src="../assets/icons/directions/turn-left.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'turn-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/turn-right.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'turn-sharp-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/turn-sharp-left.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'turn-sharp-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/turn-sharp-right.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'turn-slight-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/turn-slight-left.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'turn-slight-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/turn-slight-right.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'uturn-left'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/uturn-left.svg"></v-img>
                  <v-img v-else-if="ite.maneuver == 'uturn-right'" style="max-width: 14px !important; height: 15px; color: #fff" src="../assets/icons/directions/uturn-right.svg"></v-img>
                  <span class="ml-2" style="color: #8995A2" v-html="ite.instructions"></span>
                </div>
              </div>
            </template>  
          </div>
        </div>
      </template>
    </div>

    <v-card
      class="mt-1 mb-3"
      elevation="0"
    >
      <v-card-text
        class="py-1 px-1"
        style="position: relative;"
      >
        <div style="display:flex" class="border-point pr-1">
          <v-img style="max-width: 22px !important; height: 30px;" src="../assets/icons/point.svg"></v-img>
          <span class="ml-2" style="font-weight: bold;">{{getDirections.end_address}}</span>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
  export default {
    name: "Indications", 
    data: () => ({
      directions: {}
    }),
    computed: {
      ...mapGetters(['getDirections'])
    }
  }
</script>

<style>

.border-user {
  border-radius: 6px;
  border: 1px solid;
  font-size: 13px;
  font-weight: bold !important;
  line-height: 17px;
  padding: 5px 7px;
  background-color: #f2f2f2;
}

.border-point {
  border-radius: 6px;
  border: 1px solid #009640;
  color: #009640;
  font-size: 13px;
  font-weight: bold !important;
  line-height: 17px;
  padding: 5px 7px;
  background-color: #f2f2f2;
}
</style>